import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import API_URL from "../config";

/*
 * ResetPassword — final step of the password reset flow.
 * Route: /reset-password?token=...
 *
 * Reads the reset token from the URL, validates the new password client-side,
 * sends the update to the backend, then redirects the user back to /login.
 */
export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Keep the local validation simple and explicit before calling the backend.
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (newPassword.length < 4) {
      setError("Password must be at least 4 characters");
      return;
    }

    try {
      const res = await fetch(`${API_URL}/api/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, newPassword }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || "Reset failed");
        return;
      }

      setSuccess(true);
      setTimeout(() => navigate("/login"), 2000);
    } catch {
      setError("Server unavailable");
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        {/* Shared auth branding block. */}
        <div className="auth-logo">
          <img src="/logo-bright-orange.svg" alt="Mixtape" className="auth-logo-img" />
          <div className="auth-logo-text">
            <span className="auth-logo-title">MIXTAPE</span>
            <span className="auth-logo-sub">Your music collection</span>
          </div>
        </div>

        <h1 className="auth-heading">RESET PASSWORD</h1>
        <p className="auth-subheading">Enter your new password below.</p>

        {/* Inline validation / request error state. */}
        {error && <div className="auth-error">{error}</div>}

        {/* Replace the form with a success message once the reset finishes. */}
        {success ? (
          <div className="auth-success">
            <p>Password reset successfully! Redirecting to login...</p>
          </div>
        ) : (
          <form className="auth-form" onSubmit={handleSubmit}>
            <label className="auth-label">NEW PASSWORD</label>
            <input
              className="auth-input"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password"
            />

            <label className="auth-label">CONFIRM PASSWORD</label>
            <input
              className="auth-input"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm new password"
            />

            <button className="auth-submit" type="submit">RESET PASSWORD</button>
          </form>
        )}

        {/* Simple way back to login if the user changes their mind. */}
        <p className="auth-switch">
          <Link to="/login" className="auth-switch-link">Back to Sign in</Link>
        </p>
      </div>
    </div>
  );
}
